export const TEAL = '#3b8ea5';
export const RED = '#db324d';
